// extracted by mini-css-extract-plugin
module.exports = {"language-selector-container":"LanguageSelector_language-selector-container__RHlrE","placeholder":"LanguageSelector_placeholder__qcgj7"};